import React from "react";
import { useScrollReveal } from "../hooks/useScrollReveal";

interface LazyOnScrollProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}

export default function LazyOnScroll({ 
  children, 
  delay = 0, 
  className = "" 
}: LazyOnScrollProps) {
  const { ref, isVisible } = useScrollReveal();

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ${
        isVisible 
          ? "opacity-100 translate-y-0" 
          : "opacity-0 translate-y-8"
      } ${className}`}
      style={{
        transitionDelay: `${delay}ms`,
      }}
    >
      {children}
    </div>
  );
}